/**
 * Converts a snake_case tag string to a human-readable label.
 * e.g. "trail_cam" → "Trail cam", "food_plot" → "Food plot"
 */
export function formatTagLabel(tag: string): string {
  return tag
    .split('_')
    .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ');
}
